import BrandingThemeForm from '@/components/brandingThemes/form/BrandingThemeForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';

export default function BrandingThemeAdd() {
  return (
    <DefaultLayout header="Add Branding Theme">
      <BrandingThemeForm />
    </DefaultLayout>
  );
}
